unable to read source [project]/packages/core/src/renderer/safeInsertRule.ts